<mat-accordion class="row">
  <mat-expansion-panel
    id="entrepreneurship-panel"
    class="col-12 p-0"
    (opened)="panelOpenState = true"
    (closed)="panelOpenState = false"
    [expanded]="panelOpenState"
  >
    <mat-expansion-panel-header
      class="pt-2 pb-2 mat-expansion-panel-header"
      hideToggle
    >
      <mat-panel-title
        class="d-flex justify-content-between align-items-center pt-4 pb-4"
      >
        <div class="d-flex justify-content-center gap-2 align-items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 40 40"
            fill="none"
          >
            <path
              d="M27.5 36.2501C27.5 36.5816 27.3683 36.8995 27.1338 37.134C26.8994 37.3684 26.5815 37.5001 26.25 37.5001H13.75C13.4184 37.5001 13.1005 37.3684 12.8661 37.134C12.6317 36.8995 12.5 36.5816 12.5 36.2501C12.5 35.9186 12.6317 35.6006 12.8661 35.3662C13.1005 35.1318 13.4184 35.0001 13.75 35.0001H26.25C26.5815 35.0001 26.8994 35.1318 27.1338 35.3662C27.3683 35.6006 27.5 35.9186 27.5 36.2501ZM33.75 16.2501C33.7553 18.3339 33.2846 20.3914 32.3737 22.2656C31.4627 24.1397 30.1356 25.781 28.4937 27.0641C28.1867 27.2995 27.9376 27.6019 27.7653 27.9482C27.5931 28.2946 27.5023 28.6758 27.5 29.0626V30.0001C27.5 30.6631 27.2366 31.299 26.7677 31.7679C26.2989 32.2367 25.663 32.5001 25 32.5001H15C14.3369 32.5001 13.701 32.2367 13.2322 31.7679C12.7634 31.299 12.5 30.6631 12.5 30.0001V29.0626C12.4997 28.6804 12.4118 28.3033 12.2431 27.9604C12.0743 27.6175 11.8292 27.3178 11.5265 27.0845C9.88871 25.8089 8.56253 24.1775 7.64836 22.3137C6.7342 20.4499 6.256 18.4026 6.24996 16.3266C6.20934 8.87977 12.2281 2.67821 19.6687 2.50008C21.5021 2.4559 23.3257 2.77892 25.0324 3.45011C26.739 4.12131 28.2942 5.12712 29.6063 6.40835C30.9184 7.68958 31.9609 9.22034 32.6725 10.9105C33.3842 12.6007 33.7505 14.4162 33.75 16.2501ZM31.25 16.2501C31.2504 14.7496 30.9507 13.2641 30.3684 11.8812C29.7861 10.4982 28.933 9.24574 27.8594 8.19745C26.7858 7.14915 25.5133 6.32623 24.1168 5.77713C22.7204 5.22802 21.2282 4.96382 19.7281 5.00008C13.6343 5.14383 8.71715 10.2173 8.74996 16.311C8.75567 18.0088 9.14745 19.6831 9.89567 21.2071C10.6439 22.7312 11.7289 24.0651 13.0687 25.1079C13.671 25.5761 14.1581 26.1759 14.4929 26.8613C14.8276 27.5468 15.0011 28.2998 15 29.0626V30.0001H25V29.0626C25.0017 28.2976 25.1781 27.5431 25.5158 26.8566C25.8535 26.1702 26.3435 25.5699 26.9484 25.1016C28.2923 24.0514 29.3785 22.7079 30.124 21.1739C30.8695 19.6398 31.2546 17.9557 31.25 16.2501ZM28.7328 14.7907C28.4086 12.9802 27.5376 11.3125 26.2369 10.0121C24.9362 8.7117 23.2683 7.84101 21.4578 7.51727C21.2959 7.48998 21.1302 7.49485 20.9702 7.53159C20.8102 7.56833 20.6589 7.63623 20.5252 7.73141C20.3914 7.82659 20.2777 7.94719 20.1905 8.08631C20.1033 8.22544 20.0444 8.38038 20.0171 8.54227C19.9899 8.70417 19.9947 8.86985 20.0315 9.02987C20.0682 9.18988 20.1361 9.34109 20.2313 9.47487C20.3265 9.60864 20.4471 9.72236 20.5862 9.80953C20.7253 9.8967 20.8803 9.95561 21.0421 9.9829C23.6312 10.4188 25.8281 12.6157 26.2671 15.2095C26.3166 15.5006 26.4675 15.7648 26.6932 15.9553C26.9189 16.1458 27.2047 16.2502 27.5 16.2501C27.5706 16.2497 27.6411 16.2439 27.7109 16.2329C28.0376 16.1771 28.3288 15.9939 28.5205 15.7234C28.7121 15.4529 28.7885 15.1175 28.7328 14.7907Z"
              fill="#6813AA"
            />
          </svg>
          <h1 class="mt-3 fs-5">Empreender</h1>
        </div>
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              *ngIf="dataStoreEntrepreneurship.check"
              d="M16.2806 9.21937C16.3504 9.28903 16.4057 9.37175 16.4434 9.46279C16.4812 9.55384 16.5006 9.65144 16.5006 9.75C16.5006 9.84856 16.4812 9.94616 16.4434 10.0372C16.4057 10.1283 16.3504 10.211 16.2806 10.2806L11.0306 15.5306C10.961 15.6004 10.8783 15.6557 10.7872 15.6934C10.6962 15.7312 10.5986 15.7506 10.5 15.7506C10.4014 15.7506 10.3038 15.7312 10.2128 15.6934C10.1218 15.6557 10.039 15.6004 9.96938 15.5306L7.71938 13.2806C7.57865 13.1399 7.49959 12.949 7.49959 12.75C7.49959 12.551 7.57865 12.3601 7.71938 12.2194C7.86011 12.0786 8.05098 11.9996 8.25 11.9996C8.44903 11.9996 8.6399 12.0786 8.78063 12.2194L10.5 13.9397L15.2194 9.21937C15.289 9.14964 15.3718 9.09432 15.4628 9.05658C15.5538 9.01884 15.6514 8.99941 15.75 8.99941C15.8486 8.99941 15.9462 9.01884 16.0372 9.05658C16.1283 9.09432 16.211 9.14964 16.2806 9.21937ZM21.75 12C21.75 13.9284 21.1782 15.8134 20.1068 17.4168C19.0355 19.0202 17.5127 20.2699 15.7312 21.0078C13.9496 21.7458 11.9892 21.9389 10.0979 21.5627C8.20656 21.1865 6.46928 20.2579 5.10571 18.8943C3.74215 17.5307 2.81355 15.7934 2.43735 13.9021C2.06114 12.0108 2.25422 10.0504 2.99218 8.26884C3.73013 6.48726 4.97982 4.96451 6.58319 3.89317C8.18657 2.82183 10.0716 2.25 12 2.25C14.585 2.25273 17.0634 3.28084 18.8913 5.10872C20.7192 6.93661 21.7473 9.41498 21.75 12ZM20.25 12C20.25 10.3683 19.7661 8.77325 18.8596 7.41655C17.9531 6.05984 16.6646 5.00242 15.1571 4.37799C13.6497 3.75357 11.9909 3.59019 10.3905 3.90852C8.79017 4.22685 7.32016 5.01259 6.16637 6.16637C5.01259 7.32015 4.22685 8.79016 3.90853 10.3905C3.5902 11.9908 3.75358 13.6496 4.378 15.1571C5.00242 16.6646 6.05984 17.9531 7.41655 18.8596C8.77326 19.7661 10.3683 20.25 12 20.25C14.1873 20.2475 16.2843 19.3775 17.8309 17.8309C19.3775 16.2843 20.2475 14.1873 20.25 12Z"
              fill="#00A803"
            />
            <path
              *ngIf="!dataStoreEntrepreneurship.check"
              d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM12 20.25C10.3683 20.25 8.77326 19.7661 7.41655 18.8596C6.05984 17.9531 5.00242 16.6646 4.378 15.1571C3.75358 13.6496 3.5902 11.9908 3.90853 10.3905C4.22685 8.79016 5.01259 7.32015 6.16637 6.16637C7.32016 5.01259 8.79017 4.22685 10.3905 3.90852C11.9909 3.59019 13.6497 3.75357 15.1571 4.37799C16.6646 5.00242 17.9531 6.05984 18.8596 7.41655C19.7661 8.77325 20.25 10.3683 20.25 12C20.2475 14.1873 19.3775 16.2843 17.8309 17.8309C16.2843 19.3775 14.1873 20.2475 12 20.25ZM11.25 12.75V7.5C11.25 7.30109 11.329 7.11032 11.4697 6.96967C11.6103 6.82902 11.8011 6.75 12 6.75C12.1989 6.75 12.3897 6.82902 12.5303 6.96967C12.671 7.11032 12.75 7.30109 12.75 7.5V12.75C12.75 12.9489 12.671 13.1397 12.5303 13.2803C12.3897 13.421 12.1989 13.5 12 13.5C11.8011 13.5 11.6103 13.421 11.4697 13.2803C11.329 13.1397 11.25 12.9489 11.25 12.75ZM13.125 16.125C13.125 16.3475 13.059 16.565 12.9354 16.75C12.8118 16.935 12.6361 17.0792 12.4305 17.1644C12.225 17.2495 11.9988 17.2718 11.7805 17.2284C11.5623 17.185 11.3618 17.0778 11.2045 16.9205C11.0472 16.7632 10.94 16.5627 10.8966 16.3445C10.8532 16.1262 10.8755 15.9 10.9606 15.6945C11.0458 15.4889 11.19 15.3132 11.375 15.1896C11.56 15.066 11.7775 15 12 15C12.2984 15 12.5845 15.1185 12.7955 15.3295C13.0065 15.5405 13.125 15.8266 13.125 16.125Z"
              fill="#A31B00"
            />
          </svg>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="container-fluid py-3">
      <div class="row mb-3 pb-3 border-bottom">
        <div class="col-12 col-md-12 d-flex flex-column">
          <label class="col-12">Por que escolheu esse objetivo?</label>
          <input
            id="entrepreneurshipDescription"
            class="form-control mt-3"
            placeholder="Porque..."
            [(ngModel)]="data.motive"
            name="description"
            (ngModelChange)="setValuesForm()"
            required=""
          />
        </div>
      </div>
      <div class="row mb-3 pb-3 border-bottom">
        <div class="col-12 col-md-12">
          <label class="w-100 mb-3"
            >Quando pretende realizar esse objetivo?*</label
          >
          <input
            id="entrepreneurshipDate"
            type="date"
            name="dateentrepreneurship"
            class="col-12 col-sm-12 col-md-4 col-lg-4 p-2 rounded-1 form-control w-25"
            [(ngModel)]="data.target_date"
            (ngModelChange)="setValuesForm()"
          />
        </div>
      </div>
      <div class="row mb-3 pb-3 border-bottom">
        <div class="col-12 col-md-12">
          <label class="col-12 mb-3"
            >Quanto pretende investir nesse objetivo?*</label
          >
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-6">
              <label class="w-100">Minimo</label>
              <app-prefixed-input
                class=""
                id="entrepreneurshipMinValue"
                [elementID]="'minValueentrepreneurship'"
                [pref]="'R$'"
                (parentValue)="updateInvestmentAmount('min', $event)"
                (ngModelChange)="setValuesForm()"
                [callback]="data.investment_min"
              ></app-prefixed-input>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6">
              <label class="w-100">Máximo</label>
              <app-prefixed-input
                class="w-100"
                id="entrepreneurshipMaxValue"
                [elementID]="'maxValueentrepreneurship'"
                [pref]="'R$'"
                (parentValue)="updateInvestmentAmount('max', $event)"
                (ngModelChange)="setValuesForm()"
                [callback]="data.investment_max"
              ></app-prefixed-input>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-3 border-bottom">
        <div class="col-12">
          <label class="mb-3">Observações</label>
          <input
            id="entrepreneurshipObservation"
            class="form-control mb-3"
            placeholder="Aqui você pode colocar qualquer anotação pertinente para o objetivo."
            [(ngModel)]="data.observation"
            (ngModelChange)="setValuesForm()"
            name="observation"
          />
        </div>
      </div>
    </div>

    <div class="d-flex flex-row justify-content-between">
      <app-remove-button
        id="entrepreneurshipRemove"
        (click)="unCheck()"
      ></app-remove-button>
      <button
        id="entrepreneurship-save-btn"
        class="btn btn-primary px-2"
        mat-raised-button
        [disabled]="isLoading"
        (click)="saveForm()"
      >
        {{ buttonText }}
        <svg
          class="mb-2"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="blue"
        >
          <path
            d="M21.5306 7.28063L9.53055 19.2806C9.4609 19.3504 9.37818 19.4057 9.28713 19.4434C9.19609 19.4812 9.09849 19.5006 8.99993 19.5006C8.90137 19.5006 8.80377 19.4812 8.71272 19.4434C8.62168 19.4057 8.53896 19.3504 8.4693 19.2806L3.2193 14.0306C3.07857 13.8899 2.99951 13.699 2.99951 13.5C2.99951 13.301 3.07857 13.1101 3.2193 12.9694C3.36003 12.8286 3.55091 12.7496 3.74993 12.7496C3.94895 12.7496 4.13982 12.8286 4.28055 12.9694L8.99993 17.6897L20.4693 6.21938C20.61 6.07865 20.8009 5.99959 20.9999 5.99959C21.199 5.99959 21.3898 6.07865 21.5306 6.21938C21.6713 6.36011 21.7503 6.55098 21.7503 6.75C21.7503 6.94903 21.6713 7.1399 21.5306 7.28063Z"
            fill="#F9F9FB"
          />
        </svg>
      </button>
    </div>
  </mat-expansion-panel>
</mat-accordion>
